import { render, staticRenderFns } from "./date.vue?vue&type=template&id=5687ef89&scoped=true&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687ef89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5687ef89')) {
      api.createRecord('5687ef89', component.options)
    } else {
      api.reload('5687ef89', component.options)
    }
    module.hot.accept("./date.vue?vue&type=template&id=5687ef89&scoped=true&", function () {
      api.rerender('5687ef89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/input/date.vue"
export default component.exports